interface CheckIsSortCodeExcluded {
  excludedSortCodes: string[];
  sortCode: string;
}

export const isSortCodeExcluded = ({ excludedSortCodes, sortCode }: CheckIsSortCodeExcluded) =>
  excludedSortCodes.includes(sortCode);
